


























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiContact from '@/api/contact'
import { toSubArray } from '@/utils/groupBy'
import ReadContent from '@/components/administration/contact/read/ReadContent.vue'
import ReadMessage from '@/components/administration/contact/read/ReadMessage.vue'
import { AloContact, getDefaultAloContact } from '@/models/alo/AloContact'
import { directPayloadQuery } from '@/utils/api'
import {DashboardAdmin} from '@/router/pages'
import cloneDeep from 'clone-deep'
import { AloMedia, getDefaultAloMedia } from '@/models/alo/AloMedia'


@Component({
  name: 'ModifyContact', 
  props: {
    contactId:Number
  },
  components: { ReadContent,ReadMessage}
})

export default class ModifyContact extends Vue {
  contactId!: number
  private showError = false    
  private rightDrawer = false
  private loading = false

  get contact(){
    return this.$store.myGetters.contactDic[this.contactId] || getDefaultAloContact()
  }



  loadContact() {    
    this.loading = true    
    this.$store.myActions.ADM_CONTACT_DETAIL_REQUEST(this.contactId).finally(() => {      
      this.loading = false
      if(!this.contact.ctcLu ) this.$store.myActions.ADM_CONTACT_ACTION_ON_SELECTION_REQUEST({conIds:[this.contact.id],action:"read"});
    })    
  }

  created(){
    this.loadContact()
  }  

  get arianeItems() {
    const arianeItems =  [
        DashboardAdmin,
        {
          text: 'Contacts',
          disabled: false,  
          to: {name:'AdminContact'},        
          exact:true
        }
      ]
    if(this.contact) {
        arianeItems.push({
          text: this.contact.libelle,
          disabled: true,             
          to: {name:''},                         
          exact:true
        })
    }
    return arianeItems;
  } 

}
